import { $, $$ } from './nucleo';

//  EL MENÚ LATERAL, LA CABECERA Y LA BARRA DEL CELULAR.
//
//  Este módulo NO decide nada: abrir pestañas y cargar pantallas es de
//  `arranque.ts`. Acá sólo se MIRA lo que quedó en `#tabs` y se copia a:
//    - el título y la miga de la cabecera (la pestaña con aria-selected),
//    - el título de cada grupo (se esconde si no tiene pestañas visibles),
//    - los atajos de la barra de abajo (visibles sólo si su pestaña se ve),
//    - el grupo de la pestaña en `<body data-grupo>`: con eso el CSS pinta la
//      cabecera y el botón principal del color de la sección (D181).
//  Y maneja el selector de tamaño de letra (A·A·A, al final).
//
//  Ojo: se mira con un MutationObserver y no con llamadas desde `entrar()`;
//  las pestañas se destapan en muchos lugares (algunas tras un `await`) y una
//  llamada olvidada dejaría un grupo sin título o un atajo a una pestaña oculta.

const tabs = $('#tabs') as HTMLElement;
const lateral = $('#lateral') as HTMLElement;

function sincronizar(){
  //  Los títulos de grupo.
  $$('#tabs .grupo').forEach(g => {
    const alguna = Array.from($$('button', g)).some(b => !b.classList.contains('oculto'));
    g.classList.toggle('sin-pestanas', !alguna);
  });

  //  La cabecera.
  const activa = $('#tabs button[aria-selected="true"]') as HTMLElement | null;
  if (activa){
    const nombre = (activa.textContent || '').trim();
    const grupo = (activa.closest('.grupo') as HTMLElement | null)?.dataset.grupo || '';
    $('#tituloSeccion').textContent = nombre;
    document.body.dataset.grupo = grupo;
    const miga = $('#miga');
    miga.textContent = grupo + ' / ';
    const b = document.createElement('b');
    b.textContent = nombre;
    miga.appendChild(b);
  }

  //  La barra de abajo.
  $$('.barra-abajo button[data-ir]').forEach(x => {
    const t = (x as HTMLElement).dataset.ir;
    if (t === 'mas') return;
    const pestana = $(`#tabs button[data-t="${t}"]`);
    x.classList.toggle('oculto', !pestana || pestana.classList.contains('oculto'));
    if (pestana && pestana.getAttribute('aria-selected') === 'true')
      x.setAttribute('aria-current', 'page');
    else x.removeAttribute('aria-current');
  });
}

new MutationObserver(sincronizar).observe(tabs, {
  subtree: true, attributes: true, attributeFilter: ['class', 'aria-selected'],
});
sincronizar();

// ---------- el cajón del celular ----------
function abrirMenu(){
  lateral.classList.add('abierto');
  document.body.classList.add('cajon-abierto');
  $('#btnMenu').setAttribute('aria-expanded', 'true');
  //  Lo de atrás no se alcanza con el teclado mientras el cajón está abierto.
  document.querySelectorAll('.cuerpo, .barra-abajo').forEach(x => x.setAttribute('inert', ''));
  ($('#btnCerrarMenu') as HTMLElement).focus();
}
function cerrarMenu(){
  if (!lateral.classList.contains('abierto')) return;
  lateral.classList.remove('abierto');
  document.body.classList.remove('cajon-abierto');
  $('#btnMenu').setAttribute('aria-expanded', 'false');
  document.querySelectorAll('.cuerpo, .barra-abajo').forEach(x => x.removeAttribute('inert'));
  //  El foco vuelve al botón que abrió el cajón (si no, queda sobre algo escondido).
  ($('#btnMenu') as HTMLElement).focus();
}
$('#btnMenu').addEventListener('click', abrirMenu);
$('#btnCerrarMenu').addEventListener('click', cerrarMenu);
//  Elegir una sección cierra el cajón. `addEventListener` y no `onclick`:
//  el `onclick` de cada pestaña es el de `arranque.ts` y no se toca.
tabs.addEventListener('click', e => {
  if ((e.target as HTMLElement).closest('button')) cerrarMenu();
});
document.addEventListener('keydown', e => { if (e.key === 'Escape') cerrarMenu(); });

//  Los atajos aprietan la pestaña verdadera: así pasan por el mismo click,
//  con sus permisos y sus `cargar…()`, que si se la eligiera en el menú.
$$('.barra-abajo button[data-ir]').forEach(x => x.addEventListener('click', () => {
  const t = (x as HTMLElement).dataset.ir;
  if (t === 'mas'){ abrirMenu(); return; }
  const pestana = $(`#tabs button[data-t="${t}"]`) as HTMLElement | null;
  if (pestana && !pestana.classList.contains('oculto')){
    pestana.click();
    window.scrollTo(0, 0);
  }
}));

// ---------- las tablas que en el celular son tarjetas ----------
//  Cada celda de una `table.t-tarjetas` lleva en `data-label` el nombre de su
//  columna (el CSS lo muestra con ::before en modo tarjetas). Se copia del
//  encabezado acá, en un solo lugar: `caja.ts`, `vueltas.ts` y `circuito.ts`
//  rearman filas con innerHTML y el observador vuelve a rotular.
function rotular(){
  $$('table.t-tarjetas').forEach(t => {
    const ths = Array.from($$('thead th', t)).map(th => (th.textContent || '').trim());
    $$('tbody tr', t).forEach(tr => {
      let col = 0;
      Array.from((tr as unknown as HTMLTableRowElement).cells).forEach(td => {
        const span = (td as HTMLTableCellElement).colSpan || 1;
        const rotulo = span > 1 ? '' : (ths[col] || '');
        if (td.getAttribute('data-label') !== rotulo) td.setAttribute('data-label', rotulo);
        col += span;
      });
    });
  });
}
let pendiente = false;
new MutationObserver(() => {
  if (pendiente) return;
  pendiente = true;
  queueMicrotask(() => { pendiente = false; rotular(); });
}).observe($('main'), { subtree: true, childList: true });
rotular();

// ---------- el tamaño de letra (A · A · A, D181) ----------
//  Cambia el `font-size` de <html> por `data-letra` (todo el CSS va en rem).
//  Hay DOS selectores, el de la cabecera y el del cajón del celular, y los
//  dos se marcan juntos. Se guarda por navegador, no por usuario: alcanza.
//  El valor guardado ya lo puso el <script> del <head> antes de pintar; acá
//  sólo se marca el botón que corresponde. `localStorage` puede no estar
//  (ventana privada, sitio bloqueado): por eso los try.
const LETRAS = ['normal', 'grande', 'enorme'];
const CLAVE_LETRA = 'nubilon.letra';

function ponerLetra(valor: string){
  if (!LETRAS.includes(valor)) valor = 'normal';
  if (valor === 'normal') delete document.documentElement.dataset.letra;
  else document.documentElement.dataset.letra = valor;
  $$('.letra button[data-letra]').forEach(b =>
    b.setAttribute('aria-pressed', String((b as HTMLElement).dataset.letra === valor)));
}

$$('.letra button[data-letra]').forEach(b => b.addEventListener('click', () => {
  const valor = (b as HTMLElement).dataset.letra || 'normal';
  ponerLetra(valor);
  try { localStorage.setItem(CLAVE_LETRA, valor); } catch { /* sin guardar: igual cambia */ }
}));
ponerLetra(document.documentElement.dataset.letra || 'normal');
